module.exports = __webpack_public_path__ + "img/vindex.8041cd77.png";